import React, { useState, useEffect } from "react";
import "./TopBar.scss";
import logo from "../../assets/pacerscout.png";
import mobileLogo from "../../assets/icon.png"; // Path to the new mobile logo
import {
  MailOutlined,
  UserOutlined,
  HomeOutlined,
  StarOutlined,
} from "@ant-design/icons";
import { Button, Modal } from "antd";
import { signout } from "../../utils/Signout";
import { useNavigate, Link } from "react-router-dom";

interface TopBarProps {
  title: string;
  className?: string;
  children?: React.ReactNode; // Add children prop
}

const TopBar: React.FC<TopBarProps> = ({ title, className }) => {
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth); // State for storing window width
  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigate = useNavigate();

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    window.open("https://app.pacer.co/", "_blank");
  };

  // Hook to handle window resize event
  useEffect(() => {
    // Function to update the window width state
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array to ensure this runs only once when component mounts

  const handleLogout = async () => {
    await signout(); // Call the logout utility function
    navigate("/signin"); // Redirect to login page after logout
  };

  const handleAccountClick = () => {
    navigate("/account"); // Navigate to the account page
  };

  // New function to handle shopping cart clicks
  const handleCartClick = () => {
    navigate("/favorites");
  };

  return (
    <div className="top-bar">
      <div className="top-bar-left">
        <Link to="/landing">
          {" "}
          {/* Route to home on click */}
          <img
            src={window.innerWidth <= 768 ? mobileLogo : logo} // Conditionally render mobile or full logo
            alt="Pacer Logo"
            className="logo"
          />
        </Link>
      </div>
      <h1 className={`top-bar-title ${className}`}>{title}</h1>
      <div className="top-bar-right-icon">
        {/* New shopping cart icon */}
        <span
          className="cart-icon"
          onClick={handleCartClick}
          style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
        >
          <StarOutlined style={{ fontSize: "24px" }} />
        </span>
        <Button
          className="home-icon"
          icon={<HomeOutlined style={{ fontSize: "24px" }} />}
          onClick={showModal}
          style={{ cursor: "pointer" }}
        />
        <UserOutlined
          onClick={handleAccountClick}
          style={{ fontSize: "24px", cursor: "pointer" }}
        />
      </div>
      <Modal
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Yes"
        cancelText="No"
        closable={false}
      >
        <h3>Return to Pacer main site?</h3>
      </Modal>
    </div>
  );
};

export default TopBar;
